import React from "react"
import theme from "../../../config/theme";

const CheckBox = (props) => (
    <>
        <style jsx>{`
            input {
                position: absolute;
                opacity: 0;
                cursor: pointer;
                height: 0;
                width: 0;
            }

            label {
                position: relative;
                padding-left: 35px;
                line-height: 25px;
                font-size: ${theme.font.subtext};
                cursor: pointer;
                margin-bottom: 10px;
                display: block;
               
                ${props.original ? '' : `
                    font-weight: bold;
                    font-size: 0.8rem;
                    text-transform: uppercase;
                `}
                color: ${theme.colors.base.darkGray};
            }

            .checkmark {
                position: absolute;
                top: 0;
                left: 0;
                height: 25px;
                width: 25px;
                cursor: pointer;
                border-radius: 3px;
                background-color: ${theme.colors.base.gray};
                transition: background-color 0.10s ease-out;
                box-sizing: border-box;
            }

            label:hover input ~ .checkmark {
                box-shadow: 0px  0px 3px ${theme.colors.base.base};
            }

            label input:focus ~ .checkmark {
                box-shadow: 0px  0px 3px #CCCCCC;
            }

            label input:checked ~ .checkmark {
                background-color: ${theme.colors.base.base};
            }

            .checkmark:after {
                content: "";
                position: absolute;
                display: none;
            }

            label input:checked ~ .checkmark:after {
                display: block;
            }

            label .checkmark:after {
                left: 9px;
                top: 5px;
                width: 5px;
                height: 10px;
                border: solid ${theme.colors.base.white};
                border-width: 0 3px 3px 0;
                -webkit-transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                transform: rotate(45deg);
            }

            label.error {
                color: ${theme.colors.base.error};
            }

            label.error .checkmark {
                border: 2px solid ${theme.colors.base.error};
            }

        `}</style>
        <label className={props.error ? 'error' : ''}>
            <input type="checkbox" 
                {...props.field} checked={props.field.checked || props.field.value === true}/>
            <span className="checkmark"></span>
            <span>
                {props.label}
            </span>
        </label>  
    </>
)

export default CheckBox;